var _path, _path2, _path3, _circle, _circle2, _path4, _circle3, _circle4, _path5, _circle5, _circle6, _path6, _circle7, _circle8, _path7, _path8, _path9, _path10, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChart1Dark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 336,
    height: 139,
    viewBox: "0 0 336 139",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 136.5V36.5001C35.5 34.5001 50.8 39.2001 56 40.0001C62.5 41.0001 108 60.0001 118 62.5001C134 69.5001 153.15 72.8618 172.5 80.5001C191.5 88.0001 214 89.5001 214 89.5001H311V136.5H24Z",
    fill: "url(#paint0_linear_652_3674)",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 35C77.5691 39.3741 80.555 50.8282 110.198 60.4317C145.64 71.9137 169.727 82.0693 211.46 89.3957C211.46 89.3957 267.37 89.3957 309 89.3957",
    stroke: "url(#paint1_linear_652_3674)",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10.5C0 4.70101 4.70101 0 10.5 0H40.5C46.299 0 51 4.70101 51 10.5C51 16.299 46.299 21 40.5 21H30L25 24L20 21H10.5C4.70101 21 0 16.299 0 10.5Z",
    fill: "#5D80FF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 36,
    r: 4,
    fill: "#5D80FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 36,
    r: 5.5,
    stroke: "#3E65EF",
    strokeOpacity: 0.4,
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M285 63.5C285 57.701 289.701 53 295.5 53H325.5C331.299 53 336 57.701 336 63.5C336 69.299 331.299 74 325.5 74H315L310 77L305 74H295.5C289.701 74 285 69.299 285 63.5Z",
    fill: "#0DD15B"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 310,
    cy: 89,
    r: 4,
    fill: "#1CD774"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 310,
    cy: 89,
    r: 5.5,
    stroke: "#1CD774",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189 63.5C189 57.701 193.701 53 199.5 53H229.5C235.299 53 240 57.701 240 63.5C240 69.299 235.299 74 229.5 74H219L214 77L209 74H199.5C193.701 74 189 69.299 189 63.5Z",
    fill: "#0DD15B"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 214,
    cy: 89,
    r: 4,
    fill: "#1CD774"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 214,
    cy: 89,
    r: 5.5,
    stroke: "#1CD774",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94 37.5C94 31.701 98.701 27 104.5 27H134.5C140.299 27 145 31.701 145 37.5C145 43.299 140.299 48 134.5 48H124L119 51L114 48H104.5C98.701 48 94 43.299 94 37.5Z",
    fill: "#5D80FF"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 119,
    cy: 63,
    r: 4,
    fill: "#5D80FF"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 119,
    cy: 63,
    r: 5.5,
    stroke: "#3E65EF",
    strokeOpacity: 0.4,
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24 138.5V45",
    stroke: "#6F6D7C",
    strokeDasharray: "2 2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M119 138.5V67",
    stroke: "#6F6D7C",
    strokeDasharray: "2 2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M215 138.5V100",
    stroke: "#6F6D7C",
    strokeDasharray: "2 2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M311 138.5V99.5",
    stroke: "#6F6D7C",
    strokeDasharray: "2 2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_652_3674",
    x1: 167,
    y1: 51,
    x2: 167,
    y2: 137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E73F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E65EF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_652_3674",
    x1: 274,
    y1: 101.5,
    x2: 24.297,
    y2: 35.4268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00229167,
    stopColor: "#1CD774"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.428803,
    stopColor: "#BDFF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.629891,
    stopColor: "#4E73F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E73F9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart1Dark);
export default __webpack_public_path__ + "static/media/chart1Dark.54b356b8a67637e4001a951d881aefc5.svg";
export { ForwardRef as ReactComponent };